const EXTRAWORKINDEX = async () => await import('@/views/extra/WORK-INDEX.vue')
const COMMONGUIDE = async () => await import('@/views/extra/common-guide.vue')
const DEEPLINK = async () => await import('@/views/extra/gssm-deeplink.vue')

export const routerExtra = [
  {
    path: '/extra/WORK-INDEX',
    component: EXTRAWORKINDEX,
    name: 'WORK-INDEX',
    meta: {
      header: true,
      title: '페이지 목록',
      code: 'WORK-INDEX',
      depth2: '기타',
      requireAuth: false
    }
  },
  {
    path: '/extra/common-guide',
    component: COMMONGUIDE,
    name: 'common-guide',
    meta: {
      header: true,
      title: '공통 기능 Guide',
      code: 'common-guide',
      depth2: '기타',
      useScan: true,
      m3ScanShowItemRegBtn: true,
      isMultiScan: false,
      requireAuth: false
    }
  },
  {
    path: '/deeplink/gssm',
    component: DEEPLINK,
    name: 'deeplink',
    meta: {
      header: false,
      title: '앱 연결',
      code: 'gssm-deeplink',
      depth2: '기타',
      requireAuth: false
    }
  },
]
